import React from 'react';
export function GuaranteeSection() {
  return <section aria-labelledby="garantia" className="border-b border-line bg-canvas" data-id="element-80" data-mp="1i4znmpm6fims">
      <div className="mx-auto max-w-xl px-4 py-8 sm:py-10" data-id="element-81" data-mp="4vrz7ul6w7pa">
        <div className="rounded-2xl border-2 border-success/50 bg-success/10 p-5 text-center" data-id="element-82" data-mp="9ttj2hqfwb1t">
          <p className="font-display text-xs font-bold uppercase tracking-wide text-success sm:text-sm" data-id="element-83" data-mp="etz4vha133bz">
            Tu inversión está protegida
          </p>
          <h2 id="garantia" className="mt-1 font-display text-xl font-extrabold text-ink sm:text-2xl" data-id="element-84" data-mp="jqg1kzvamq0o">
            🛡️ Garantía total de 7 días
          </h2>
          <p className="mt-2 text-sm leading-snug text-muted" data-id="element-85" data-mp="slvthbchmv3m">
            Tienes 7 días para explorar los 6 tomos y los 5 bonos. Si consideras
            que el sistema no es adecuado para ti, puedes solicitar un reembolso
            dentro del período establecido según los términos de devolución.
          </p>
        </div>
      </div>
    </section>;
}